<style lang="scss" scoped>
.card {
  margin: 0 0.5rem;
}
.btn-group {
  margin-right: 10px;
}
i:hover {
  cursor: pointer;
}
img {
  max-width: 100%;
  min-width: 100%;
  max-height: 100%;
  min-height: 100%;
}
audio {
  max-width: 100%;
  min-width: 100%;
  max-height: calc(150px - 2rem);
}
.at-check-overlay {
  opacity: 0.8;
  filter: alpha(opacity=80); /* For IE8 and earlier */
  position: absolute;
  top: 45%;
  width: 100%;
  height: 20%;
  background-color: $black;
  color: $white;
}
.erotic {
  opacity: 0.8;
  filter: alpha(opacity=80); /* For IE8 and earlier */
  position: absolute;
  top: 70%;
  width: 100%;
  height: 19%;
  transform: rotate(-45deg);
  transform-origin: -20% 55%;
  background-color: $danger;
  color: $white;
}
.img-overlay {
  position: relative;
  max-width: 100%;
  overflow: hidden;
}
.border-2 {
  border-width: 2px !important;
}
</style>

<template>
  <div class="card border-0 p-0 pb-3 m-0">
    <div class="card-body p-0">
      <div class="img-overlay">
        <img
          v-if="entry.is_image"
          class="border border-2"
          :src="entry.url"
          :class="{
            'border-success': entry.is_primary,
            'border-danger': entry.is_erotic,
            'border-warning': !entry.confirmed && !entry.is_erotic
          }"
        />
        <div
          v-if="!entry.confirmed && !entry.is_erotic"
          class="at-check-overlay text-xl text-center text-vcenter"
        >
          In Prüfung
        </div>
        <div
          v-if="entry.is_erotic"
          class="erotic text-xl text-center text-vcenter"
        >
          Erotisch
        </div>
      </div>
      <audio
        v-if="entry.is_audio"
        class="media border border-2"
        :src="entry.url"
        controls
        :class="{
          'border-success': entry.is_primary,
          'border-danger': entry.is_erotic,
          'border-warning': !entry.confirmed && !entry.is_erotic
        }"
      ></audio>
      <div class="row pt-2">
        <div class="col-12">
          <div class="row pl-3">
            <i
              v-if="
                entry.confirmed && !entry.is_erotic && !entry.settingPrimary
              "
              class="fas fa-check pl-2"
              @click="setPrimary(entry)"
              :class="{
                'text-grey': !entry.is_primary,
                'text-success': entry.is_primary
              }"
            ></i>
            <i
              v-else-if="entry.confirmed && !entry.is_erotic"
              class="fas fa-spinner fa-spin pl-2"
            ></i>
            <i v-if="entry.is_erotic" class="text-grey fa fa-ban pl-2"></i>
            <i
              v-if="!entry.deleting"
              @click="destroy(entry)"
              class="text-danger fas fa-trash-alt pl-2"
            ></i>
            <i v-else class="fas fa-spinner fa-spin pl-2"></i>
            <p
              v-if="entry.is_audio && entry.confirmed === null"
              class="bg-dark ml-2 mb-2 pl-2 pr-2 text-white"
            >
              In Prüfung
            </p>
            <p
              v-if="entry.is_audio && entry.is_erotic"
              class="bg-danger ml-2 mb-2 pl-2 pr-2 text-white"
            >
              Erotisch
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    entry: {
      required: true,
      type: Object
    }
  },
  methods: {
    destroy() {
      this.$emit("destroy");
    },
    setPrimary() {
      this.$emit("setPrimary");
    }
  }
};
</script>
